var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/services/broadlink/lib/utils/broadlink.constants.js
var require_broadlink_constants = __commonJS({
  "server/services/broadlink/lib/utils/broadlink.constants.js"(exports, module) {
    var ACTIONS = {
      LEARN: {
        SUCCESS: "success",
        ERROR: "error",
        CANCEL_ERROR: "cancel_error",
        CANCEL_SUCCESS: "cancel_success",
        NO_PERIPHERAL: "no_peripheral"
      },
      SEND: {
        SUCCESS: "success",
        ERROR: "error"
      }
    };
    var PARAMS = {
      IR_CODE: "ir_code_",
      PERIPHERAL: "peripheral",
      MANUFACTURER: "manufacturer",
      REMOTE_TYPE: "remote_type"
    };
    var POLL_TIMEOUT = 10 * 1e3;
    module.exports = {
      ACTIONS,
      PARAMS,
      POLL_TIMEOUT
    };
  }
});
const __cjsModule = require_broadlink_constants();
export default __cjsModule;
export const ACTIONS = __cjsModule.ACTIONS;
export const PARAMS = __cjsModule.PARAMS;
export const POLL_TIMEOUT = __cjsModule.POLL_TIMEOUT;
